import { SupportUploadModal } from "./SupportUpload";

const SUPPORT_UPLOAD_ENVIRONMENTS = new Set(["dev", "local"]);

export function isSupportUploadEnabled(env?: string): boolean {
  return SUPPORT_UPLOAD_ENVIRONMENTS.has(env || "");
}

export function getSupportUploadMenuItem(onClick: () => void): {
  id: string;
  label: string;
  clickHandler: () => void;
} {
  return {
    id: "support-upload",
    label: "Upload Image",
    clickHandler: onClick,
  };
}

export { SupportUploadModal };
